import { createTheme } from "@mui/material/styles";
import {
  FLEX_ALIGN_CENTER,
  FONT_SIZE_XL,
  FONT_WEIGHT_BOLD,
  LINE_HEIGHT_XL,
  POSITION_RELATIVE,
  WIDTH_FIT_CONTENT,
  FONT_WEIGHT_NORMAL,
  FONT_SIZE_MD,
  TEXT_DECORATION_NONE,
  FONT_SIZE_XXL,
  LINE_HEIGHT_MD,
  FONT_SIZE_SM,
  LINE_HEIGHT_SM,
  FONT_SIZE_LG,
  FONT_SIZE_XS,
  LINE_HEIGHT_XS,
  FONT_SIZE_XXXL,
} from "./styles";
import { colors } from "./colors";

export const theme = createTheme({
  typography: {
    fontFamily: '"DM Sans", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      position: POSITION_RELATIVE,
      width: WIDTH_FIT_CONTENT,
      fontFamily: "DM Sans,sans-serif",
      fontWeight: FONT_WEIGHT_BOLD,
      color: colors.custom,
      fontSize: FONT_SIZE_XXXL,
      textAlign: FLEX_ALIGN_CENTER,
      lineHeight: FONT_SIZE_XXXL,
      letterSpacing: "-0.32px",
    },
    h2: {
      position: POSITION_RELATIVE,
      width: WIDTH_FIT_CONTENT,
      fontFamily: "DM Sans,sans-serif",
      fontWeight: FONT_WEIGHT_BOLD,
      color: colors.primary,
      fontSize: FONT_SIZE_XL,
      textAlign: FLEX_ALIGN_CENTER,
      lineHeight: LINE_HEIGHT_XL,
    },
    h3: {
      position: POSITION_RELATIVE,
      width: WIDTH_FIT_CONTENT,
      fontFamily: "DM Sans,sans-serif",
      fontWeight: FONT_WEIGHT_NORMAL,
      color: colors.custom,
      fontSize: FONT_SIZE_XL,
      textAlign: FLEX_ALIGN_CENTER,
      lineHeight: LINE_HEIGHT_XL,
    },
    h4: {
      position: POSITION_RELATIVE,
      fontFamily: "Open Sans,sans-serif",
      fontWeight: FONT_WEIGHT_NORMAL,
      color: colors.grayLight,
      fontSize: FONT_SIZE_SM,
      lineHeight: LINE_HEIGHT_SM,
      textDecoration: TEXT_DECORATION_NONE,
    },
    h5: {
      position: POSITION_RELATIVE,
      fontFamily: "Open Sans,sans-serif",
      fontWeight: FONT_WEIGHT_BOLD,
      color: colors.custom,
      fontSize: FONT_SIZE_LG,
      lineHeight: LINE_HEIGHT_MD,
    },
    h6: {
      position: POSITION_RELATIVE,
      fontFamily: "Open Sans,sans-serif",
      fontWeight: FONT_WEIGHT_NORMAL,
      color: colors.custom,
      fontSize: FONT_SIZE_XS,
      lineHeight: LINE_HEIGHT_XS,
    },
    subtitle2: {
      fontFamily: "Open Sans,sans-serif",
      fontWeight: FONT_WEIGHT_NORMAL,
      color: colors.custom,
      fontSize: FONT_SIZE_MD,
      textAlign: FLEX_ALIGN_CENTER,
      lineHeight: "18px",
    },
    body1: {
      position: POSITION_RELATIVE,
      width: WIDTH_FIT_CONTENT,
      fontFamily: "Open Sans,sans-serif",
      fontWeight: FONT_WEIGHT_BOLD,
      fontSize: FONT_SIZE_MD,
      textAlign: FLEX_ALIGN_CENTER,
      lineHeight: "18px",
      textDecoration: TEXT_DECORATION_NONE,
    },
    body2: {
      position: POSITION_RELATIVE,
      width: WIDTH_FIT_CONTENT,
      fontFamily: "Open Sans,sans-serif",
      fontSize: FONT_SIZE_XXL,
      fontWeight: FONT_WEIGHT_BOLD,
      lineHeight: "28px",
      letterSpacing: "-0.8px",
      color: colors.custom,
    },
  },
  palette: {
    primary: {
      main: "#7950FF",
      input: "#0D1943",
      dark: "#6F42C1",
    },
    secondary: {
      main: "#DC004E",
      contrastText: "#fff",
    },
    background: {
      default: "#F5F5F5",
      active: "#ECE6FF",
      secondary: "#ced1d9",
    },
    text: {
      primary: "#0E0E0E",
      primary_hover: "#F1F1F1",
      secondary: "#999",
      secondary_hover: "#CEBFFF",
      danger: "#ff0000",
    },
  },
});
